import React, { Component } from "react";
import ApprovalInformation from "../../Common/ApprovalInformation";
import { main_url, getBranch, fno } from "../../../utils/CommonFunction";
import DocumentList from "../../Common/DocumentList";
import Select from "react-select";
import EamPaymentApprovalInformation from "../../Common/EamPaymentApprovalInformation";
import { getHeaders } from "../../../utils/apiHelper";

class MedicalBenefitView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      document: [],
      status_info: [],
      selected_location: [], //Added by STHA
      branch: [], //Added by STHA
      eamPaymentDetailsInfo: [],
    };
  }

  componentDidMount() {
    this.getMedicalDocument();
    this.getStatusInfo();
    this.getAllBranches();
    this.getEamPaymentInfo();
  }

  //Added by STHA to get EAM Payment Info
  getEamPaymentInfo() {
    let form_no = this.state.data.form_no; // Form Number
    let type = "Medical";
    fetch(`${main_url}eam_payment/getEamPaymentInfo/${form_no}/${type}`, {
      headers: getHeaders(),
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          eamPaymentDetailsInfo: res,
        });
      })
      .catch((error) => console.log(error));
  }
  //Added by STHA
  async getAllBranches() {
    let branch = await getBranch();
    let selected_location = this.getSelectedLocation(
      branch,
      this.props.data.withdraw_location
    );
    this.setState({
      branch: branch,
      selected_location: selected_location,
    });
  }

  //Added by STHA
  getSelectedLocation(branch, location) {
    let selected = branch.filter(function (b) {
      return b.value === location;
    });
    return selected;
  }

  getMedicalDocument() {
    fetch(
      `${main_url}medical_benefit/getDocument/${this.state.data.medical_benefit_id}`, {
        headers: getHeaders(),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          document: res,
        });
      })
      .catch((error) => console.log(error));
  }

  getStatusInfo() {
    fetch(
      `${main_url}medical_benefit/getOneDetailInfo/${this.state.data.medical_benefit_id}`, {
        headers: getHeaders(),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          status_info: res,
        });
      })
      .catch((error) => console.log(error));
  }
  render() {
    return (
      <div className="benefits benefit-medical  wrapper border-bottom white-bg page-heading">
        <div className="row ">
          <form className="form-group">
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Voucher No.
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    value={fno.fno_medical + this.state.data.form_no}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Employee Name
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.data.fullname}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="available-amount" className="col-sm-12">
                    {" "}
                    Beneficiary{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text "
                    disabled
                    className="form-control"
                    value={this.state.data.type_name}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="training-type" className="col-sm-12">
                    {" "}
                    Available Amount{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control"
                    disabled
                    value={this.state.data.available_amount}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="amount" className="col-sm-12">
                    Request Amount{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control"
                    disabled
                    value={this.state.data.request_amount}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="name-of-beneficiary" className="col-sm-12">
                    Name of Beneficiary{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    disabled
                    value={this.state.data.beneficary_name}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="description" className="col-sm-12">
                    Description{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <textarea
                    name="description"
                    className="form-control"
                    cols="10"
                    rows="3"
                    value={this.state.data.description}
                  ></textarea>
                </div>
              </div>
              {/* Added by STHA */}
              <div className="col-md-6 form-group">
                <div>
                  <label className="col-sm-12">
                    WithDraw Location<span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-sm-10">
                  <Select
                    data-name="withdraw_loction"
                    value={this.state.selected_location}
                    isDisabled={true}
                    // onChange={this.changeWithdrawLocation}
                    // options={this.state.branch}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              {/* Added end by STHA */}
            </div>
          </form>
        </div>
        <div className="row document-main">
          {this.state.document.length > 0 ? (
            <DocumentList
              title="Medical Benefit Document"
              doc={this.state.document}
              path="medical_benefit"
            />
          ) : (
            ""
          )}
        </div>
        <div className="row approval-main">
          {!Array.isArray(this.state.status_info) ? (
            <div className="margin-top-20">
              <ApprovalInformation status={this.state.status_info} />
              {this.state.eamPaymentDetailsInfo &&
                this.state.eamPaymentDetailsInfo.length > 0 && (
                  <EamPaymentApprovalInformation
                    eamPaymentDetailsInfo={this.state.eamPaymentDetailsInfo}
                  />
                )}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default MedicalBenefitView;
